<template>
    <section class="available-languages" :class="variant">
        <div class="dropdown">
            <button class="btn btn-white btn-as-input dropdown-toggle" :class="{ 'opened-menu': showList }" type="button"
                id="dropdown-language-lists" aria-expanded="false" @click="showList = !showList">
                <LanguageItem :item="currentLanguage" :variant="variant" />
                <img src="@/assets/icons/panel/header/arrow.svg" class="dropdown-arrow" />
            </button>
            <ul class="dropdown-menu available-languages__list" :class="showList ? 'show-menu' : ''"
                aria-labelledby="dropdown-language-lists">
                <li v-for="(item, key) in internalAvailableLanguages" :key="key" @click="changeLanguage(item)">
                    <a class="dropdown-item">
                        <LanguageItem :item="item" :variant="variant" />
                    </a>
                </li>
            </ul>
        </div>
    </section>
</template>
<script charset="utf-8">
import i18nService from '../../services/i18n.service';
import LanguageItem from "./LanguageItem.vue"
import i18n from '../../helpers/i18n.helper';
export default {
    name: "LanguageSwitcher",
    emits: ["update:modelValue"],
    components: {
        LanguageItem
    },
    props: {
        variant: {
            type: String,
            default: ""
        },
        modelValue: {
            type: Object
        }
    },
    data() {
        return {
            internalAvailableLanguages: [],
            showList: false
        }
    },
    computed: {
        currentLanguage() {
            const language = this.internalAvailableLanguages.find(item => item.code === this.$i18n.locale);
            this.$emit('update:modelValue', language);
            return language;
        },
        isPublicSessionInfo() {
            return this.$route.name === 'PublicSessionInfo';
        }
    },
    // celowo created
    async created() {
        this.internalAvailableLanguages = await i18nService.getAvailableLanguages();
    },
    methods: {
        async changeLanguage(languageItem) {
            try {
                this.$store.commit("showLoader");
                this.showList = false;
                this.$i18n.locale = languageItem.code;

                if (this.isPublicSessionInfo) {
                    await this.$router.push({
                        name: this.$route.name,
                        params: { ...this.$route.params },
                        query: { ...this.$route.query, lang: languageItem.code }
                    })
                }
                else {
                    const messageResult = await i18nService.geti18nMessages(languageItem.id);
                    if (messageResult.status !== 200) {
                        throw await Promise.reject(messageResult)
                    }
                    await i18nService.setLocale(languageItem);
                    i18n.global.setLocaleMessage(languageItem.code, messageResult.data)
                    this.$emit('update:modelValue', languageItem);
                }
            }
            catch (e) {
                console.log(e);
            }
            finally {
                this.$store.commit("hideLoader");
            }
        }
    }
}
</script>
<style lang="scss">
.available-languages {
    .btn-white {
        background: #ffffff;
        border: 1px solid #d1d6df;
        padding: 10px 20px;
    }

    .dropdown {
        position: relative;
        float: left;

        .dropbtn {
            font-size: 16px;
            border: none;
            outline: none;
            color: #000;
            padding: 38px 20px 38px 20px;
            background-color: inherit;
            font-family: inherit;
            /* Important for vertical align on mobile phones */
            margin: 0;
            /* Important for vertical align on mobile phones */
            font-weight: 500;
            font-size: 16px;
            line-height: 132%;
            display: flex;
            column-gap: 10px;
            align-items: center;

            .menu-icon {
                height: 20px;
            }
        }

        .dropdown-menu {
            position: absolute;
            z-index: 1000;
            display: none;
            min-width: 10rem;
            padding: .5rem 0;
            margin: 0;
            font-size: 1rem;
            color: #212529;
            text-align: left;
            list-style: none;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, .15);
            border-radius: .25rem;
            overflow: hidden;

            .dropdown-item {
                display: block;
                width: 100%;
                padding: .25rem 1rem;
                clear: both;
                font-weight: 400;
                color: #212529;
                text-align: inherit;
                text-decoration: none;
                white-space: nowrap;
                background-color: transparent;
                border: 0;
                cursor: pointer;

                &:hover {
                    color: #1e2125;
                    background-color: #e9ecef;
                }
            }
        }

        .show-menu {
            position: absolute;
            inset: 0px auto auto 0px;
            margin: 0px;
            transform: translate(0px, 45px);
            display: unset;
            border-top-left-radius: 0px;
            border-top-right-radius: 0px;
        }

        .opened-menu {
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        }

        .dropdown-content {
            max-height: 50vh;
            display: none;
            position: absolute;
            background-color: #fff;
            min-width: 160px;
            box-shadow: 0px 10px 9px 0px #b1b1b1;
            z-index: 1;

            .menu-item {
                padding: 10px 0px 10px 20px;
                float: none;
                display: flex;
                text-align: left;
            }
        }

        &:hover {
            background-color: #e8ebef;

            .dropdown-content {
                display: block;
            }
        }
    }
}
</style>